type StructuredName = {
  given_name: string;
  family_name: string;
};

export const nameListForm = ({ given_name, family_name }: StructuredName) => {
  return given_name.trim() ? `${family_name}, ${given_name}` : family_name;
};

export const nameNaturalForm = ({
  given_name,
  family_name,
}: StructuredName) => {
  return `${given_name} ${family_name}`.trim();
};
